// hooks/useDebounce.js
import { useState, useEffect } from "react";

const useDebounce = (value, delay = 400) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delay);
    return () => clearTimeout(timer); // cleanup cancels pending call on every keystroke
  }, [value, delay]);

  return debouncedValue;
};

export default useDebounce;